'use strict';

export default function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}



//////////////////
// WEBPACK FOOTER
// E:/项目/渠道推广统计/statisticsLizu/node_modules/axios/lib/helpers/parseProtocol.js
// module id = null
// module chunks = 